import React, { useEffect, useState } from 'react';
import Multiselect from 'multiselect-react-dropdown';
import { useDispatch, useSelector } from "react-redux";
import { updateAudienceByOwner, updateAudience, sendUpdateAudienceRequestByOwners, audienceApprovedByApprover } from '../../../../../../actions/audienceActions'
import { useForm } from "react-hook-form";
import * as yup from "yup";
import { yupResolver } from '@hookform/resolvers/yup';
import DisapproveModal from '../../../ReusableComponent/DisapproveModal'
import moment from 'moment';

const SecondaryAudience = (props) => {

    const dispatch = useDispatch();
    const { user } = useSelector(state => state.auth);
    const { loading } = useSelector(state => state.audiencesStore);

    const [members, setMembers] = useState([]);
    const [inputAudience, setInputAudience] = useState("");
    const [inputAudienceInsightse, setInputAudienceInsightse] = useState("");
    const [inputAudienceOwner, setInputAudienceOwner] = useState([]);
    const [inputAudienceApprover, setInputAudienceApprover] = useState([]);
    const [inputID, setInputID] = useState("");
    const [inputProjectId, setInputProjectId] = useState("");

    const [inputProjectClientId, setInputProjectClientId] = useState("");
    const [inputProjectPartners, setInputProjectPartners] = useState([]);
    const [isCurrentOwner, setIsCurrentOwner] = useState(false);
    const [showRejectModal, setAddRejectModal] = useState(false);
    const [selectedRowData, setselectedRowData] = useState(false);
    const [rejectedReasonData, setRejectedReasonData] = useState([]);
    const [rejectedReasonVisible, setRejectedReasonVisible] = useState(false);
    const [isApproved, setIsApproved] = useState(false);
    const [isApprover, setIsApprover] = useState(false);
    const [isOwner, setIsOwner] = useState(false);
    const [isClientPartner, setIsIsClientPartner] = useState(false);
    const [isTextVisible, setIsTextVisible] = useState(true);
    const [isOwnerApproverDisable, setIsOwnerApproverDisable] = useState(false);
    const [isRejected, setIsRejected] = useState(false);

    const validationSchema = yup.object().shape({
        isOwner: yup.boolean(),
        audience: yup.string().nullable().when('isOwner', {
            is: true,
            then: yup.string().required('This filed is required').nullable()
        }),
        audienceInsights: yup.string().nullable().when('isOwner', {
            is: true,
            then: yup.string().required('This filed is required').max(300, 'Background text should be less then 300 words').nullable()
        }),
        audienceOwner: yup.array(),
        audienceApprover: yup.array(),
        isApproved: yup.boolean(),
    });

    const { register, handleSubmit, setValue, formState: { errors } } = useForm({
        mode: "onBlur",
        resolver: yupResolver(validationSchema),
    });
    useEffect(() => {
        if (props.data) {
            setValue('audience', props?.secondaryAudience?.audience_type_id)
            setValue('audienceInsights', props?.secondaryAudience?.insights_text)
            setValue('audienceOwner', props?.secondaryAudience?.owner_members)
            setValue('audienceApprover', props?.secondaryAudience?.approver_members)
            setInputAudience(props.secondaryAudience?.audience_type_id);
            setInputAudienceInsightse(props?.secondaryAudience?.insights_text);
            setInputAudienceOwner(props?.secondaryAudience?.owner_members || [])
            setInputAudienceApprover(props?.secondaryAudience?.approver_members || [])
            setInputID(props?.secondaryAudience?.id);
            setRejectedReasonData(props?.secondaryAudience?.audience_rejections || [])
            setIsApproved(props?.secondaryAudience?.is_approved)
            setIsRejected(props?.secondaryAudience?.is_rejected)
            setMembers(props?.members || [])
            setInputProjectClientId(props.data?.client_id)
            setInputProjectId(props.data?.id)
            setInputProjectPartners(props?.data?.partners || [])
        }

    }, [props.data, props.members, props.secondaryAudience, setValue]);

    useEffect(() => {
        if (inputAudienceOwner || inputProjectPartners) {
            var isOwner;
            inputAudienceOwner?.find(function (value) {
                if (value.id === user.user_id) {
                    return isOwner = value;
                }
                return isOwner;
            });
            var isPartners
            inputProjectPartners?.find(function (value) {
                if (value.id === user.user_id) return isPartners = value;
                return isPartners;
            });
            var isApproverModule
            inputAudienceApprover?.find(function (value) {
                if (value.id === user.user_id) return isApproverModule = value;
                return isApproverModule;
            });
            if (inputProjectClientId === user.user_id) {
                setIsCurrentOwner(true)
                setIsApprover(false)
                setIsTextVisible(true)
                setIsOwnerApproverDisable(false)
                setIsIsClientPartner(true)
                setRejectedReasonVisible(true)
            }
            else if (isPartners) {
                setIsCurrentOwner(true)
                setIsApprover(false)
                setIsTextVisible(true)
                setIsOwnerApproverDisable(false)
                setIsIsClientPartner(true)
            }
            else if (isOwner && isApproverModule) {
                if (isApproved) setIsTextVisible(true);
                else setIsTextVisible(false);
                setIsApprover(true)
                setIsCurrentOwner(true)
                setIsOwnerApproverDisable(true)
                setValue('isOwner', true)
                setIsOwner(true)
                setRejectedReasonVisible(true)
            }
            else if (isOwner) {
                if (isApproved) setIsTextVisible(true);
                else setIsTextVisible(false);
                setIsCurrentOwner(true)
                setIsOwnerApproverDisable(true)
                setValue('isOwner', true)
                setIsOwner(true)
                setRejectedReasonVisible(true)
            }
            else if (isApproverModule) {
                setIsApprover(true)
                setIsTextVisible(true)
                setIsOwnerApproverDisable(true)
                setRejectedReasonVisible(true)
            }
            else {
                setIsCurrentOwner(false)
                setIsOwnerApproverDisable(true)
                setIsTextVisible(true)
            }

        }

    }, [inputAudienceOwner, inputProjectPartners, user, inputAudienceApprover, inputProjectClientId, isApproved, setValue])

    const onMemberSubmit = async (values, e) => {

        const formData = {
            project_id: inputProjectId,
            audience_type: '2',
            owner_members: values.audienceOwner,
            approver_members: values.audienceApprover,
        }
        const formDataOwner = {
            id: inputID,
            project_id: inputProjectId,
            audience_type_id: values.audience,
            audience_type: '2',
            insights_text: values.audienceInsights,
        }
        console.log(formData, ' Form values')
        if (isClientPartner) dispatch(updateAudience(formData))
        else if (isOwner) dispatch(updateAudienceByOwner(formDataOwner))
        else return false;

    }
    const handelChange = (e) => {
        setValue('audienceOwner', e, { shouldValidate: true })
        setInputAudienceOwner(e)
    }
    const handelChangeApprover = (e) => {
        setValue('audienceApprover', e, { shouldValidate: true })
        setInputAudienceApprover(e)
    }

    const handleAddReasonClose = () => {
        setAddRejectModal(false);
        setselectedRowData(false);
    };

    const handleReasonShow = () => {
        setselectedRowData(inputProjectId);
        setAddRejectModal(true);
    };
    const handelRequestToEdit = () => {
        const data = { id: inputID, project_id: inputProjectId }
        dispatch(sendUpdateAudienceRequestByOwners(data))
    };
    const handelAudienceApproved = () => {
        const data = { id: inputID, project_id: inputProjectId }
        dispatch(audienceApprovedByApprover(data))
    };

    return (
        <>
            <form className="form-auth-small" onSubmit={handleSubmit(onMemberSubmit)}>
                <div className="row">
                    <div className="col-lg-6 col-md-6 col-sm-12">
                        <div className="form-group">
                            <label htmlFor="title" className="control-label">Audience<span className='text-danger'>*</span></label>
                            <select name="title" id="title"
                                disabled={isTextVisible}
                                className="form-control"
                                defaultValue={inputAudience}
                                onChange={(e) => setInputAudience(e.target.value)}
                                {...register('audience')} >
                                <option value=''>Select</option>
                                {props.audienceTypes && props.audienceTypes.map((audience, index) => (
                                    <option key={index} value={audience.id}>{audience.name}</option>
                                ))}
                            </select>
                            {errors.audience && (
                                <div className="text-danger pt-2">{errors.audience.message}</div>
                            )}
                        </div>
                    </div>
                </div>
                <div className="row">
                    <div className="col-lg-12 col-md-6 col-sm-12">
                        <div className="form-group">
                            <label htmlFor="insights" className="control-label">Insights<span className='text-danger'>*</span></label>
                            <textarea
                                rows={5}
                                className="form-control"
                                defaultValue={inputAudienceInsightse}
                                disabled={isTextVisible}
                                placeholder='Please Enter Insights'
                                onChange={(e) => setInputAudienceInsightse(e.target.value)}
                                name="audienceInsights"
                                {...register('audienceInsights')}
                            />
                            {errors.audienceInsights && (
                                <div className="text-danger pt-2">{errors.audienceInsights.message}</div>
                            )}
                        </div>
                    </div>
                </div>
                <div className='row'>
                    <div className="col-lg-12 col-md-12 col-sm-12">
                        <div className="form-group">
                            <label htmlFor="job_number" className="control-label">Select Owners</label>
                            <Multiselect
                                options={members}
                                selectedValues={inputAudienceOwner}
                                displayValue="name"
                                onSelect={(e) => handelChange(e)}
                                onRemove={(e) => handelChange(e)}
                                {...register('audienceOwner')}
                                showArrow={true}
                                disable={isOwnerApproverDisable}
                            />
                            {errors.audienceOwner && (
                                <div className="text-danger pt-2">{errors.audienceOwner.message}</div>
                            )}
                        </div>
                    </div>
                </div>
                <div className='row'>
                    <div className="col-lg-12 col-md-12 col-sm-12">
                        <div className="form-group">
                            <label htmlFor="job_number" className="control-label">Select Approvers
                            </label>
                            <Multiselect
                                options={members}
                                selectedValues={inputAudienceApprover}
                                displayValue="name"
                                onSelect={(e) => handelChangeApprover(e)}
                                onRemove={(e) => handelChangeApprover(e)}
                                {...register('audienceApprover')}
                                showArrow={true}
                                disable={isOwnerApproverDisable}
                            />
                            {errors.audienceApprover && (
                                <div className="text-danger pt-2">{errors.audienceApprover.message}</div>
                            )}
                        </div>
                    </div>
                </div>

                <div className='row px-2 pb-3 clearfix'>
                    <div className='col-md-12 col-lg-12 col-sm-12  text-center'>
                        {isCurrentOwner ? <button className='btn mx-2 custom-btn-outline-info' disabled={(isOwner && isApproved) || loading ? true : false} type='submit'>Update</button> : null}
                        {isApprover ? <button onClick={() => handelAudienceApproved()} className='btn btn-outline-info mx-2' disabled={isApproved || loading ? true : false} type='button'>Approved</button> : null}
                        {isApprover ? <button onClick={() => handleReasonShow()} className='btn btn-outline-danger mx-2' disabled={isApproved || isRejected || loading ? true : false} type='button'>Reject</button> : null}
                        {isOwner && isApproved ? <button onClick={() => handelRequestToEdit()} className='btn button mx-2' disabled={isApproved === false ? true : false} type='button'>Request To Edit</button> : null}
                    </div>
                </div>
                {rejectedReasonVisible ?
                    <>
                        <div className='row px-2 pb-3 clearfix'>
                            <h5>Rejected Reasons</h5>
                            <div className='col-md-12 col-lg-12 col-sm-12'>
                                {rejectedReasonData && rejectedReasonData.map((reason, index) => (
                                    <p key={index}>{reason.rejection_reason} : <span>{moment(reason.rejection_date).format('DD-MM-YYYY hh:mm')}</span></p>
                                ))}
                            </div>
                        </div>
                    </>
                    : null}
            </form>
            <DisapproveModal
                component_id={inputID}
                open={showRejectModal}
                close={handleAddReasonClose}
                data={selectedRowData}
                component={'Audience'}
            />
        </>
    );
};
export default SecondaryAudience;